import api from './api.service';
 class AuthService {
    login(email: string, password: string) {
        return api.post('auth/login', {email, password});
    }
    forgotPassword(email: string) {
        return api.post('auth/forgot-password', {email});
    }
    resetPassword(password: string) {
        const token = localStorage.getItem('token');
        return api.post('auth/reset-password', {password, token});
    }
    getGoogleUrl() {
        return api.post('auth/google/url', {url: 'string'});
    }
    googleAuth(authorization_code: string, state: string) {
        return api.post('auth/google/authorization', {
            authorization_code,
            state
        });
    }
    getFacebookUrl() {
        return api.post('auth/facebook/url', {url: 'string'});
    }
    facebookAuth(authorization_code: string, state: string) {
        return api.post('auth/facebook/authorization', {
            authorization_code,
            state
        });
    }
}

export const authService = new AuthService();
